module.exports = __webpack_public_path__ + "static/media/footer.702d0b74.png";